<template>
  <div>
    <modal :title="$t('public.calibration')" :visible.sync="isShowDialog" width="700px" @close="reset">
      <el-form ref="form" :model="dioForm">
        <!-- 是否开启校验 -->
        <el-form-item prop="type">
          <el-radio v-model="dioForm.type" :label="1">{{ $t('device.start_calibration') }}</el-radio>
          <el-radio v-model="dioForm.type" :label="0">{{ $t('device.no_calibration') }}</el-radio>
        </el-form-item>
        <template v-if="dioForm.type">
        <!-- 校验到期时间 -->
        <el-form-item :label="$t('device.calibration_expiration_date')" prop="expireTime">
          <el-date-picker
            v-model="dioForm.expireTime"
            type="date"
            :disabled="!dioForm.type"
            :placeholder="$t('public.select_time')"
            :picker-options="pickerOptions"
            >
          </el-date-picker>
        </el-form-item>
        <!-- 校验通知 -->
        <el-form-item>
          <el-checkbox v-model="noticeChecked" :disabled="!dioForm.type" @change="noticeChange">{{ $t('device.calibration_notice') }}</el-checkbox>
        </el-form-item>
        <el-form-item>
          {{ $t('device.advance') }}
          <el-input v-model.number="dioForm.day" style="width: 70px" maxlength="5"
             :disabled="!dioForm.type || dioForm.type && !noticeChecked"
             oninput="value=value.replace(/[^\d.]/g, '')"  />
          {{ $t('public.day') }},
          {{ $t('resource.in')}}
          <el-time-picker
            v-model="dioForm.time"
            :disabled="!dioForm.type || dioForm.type && !noticeChecked"
            style="width: 150px;"
            format="HH:mm"
            value-format="HH:mm"
          >
          </el-time-picker>
          {{ $t('device.notice') }}
          <!-- 新增通知对象 -->
          <!-- <el-dropdown split-button type="primary"
            class="add_object_btn"
            :disabled="!dioForm.type || dioForm.type && !noticeChecked"
            @click="addObject"
          >
            {{ $t('device.add_notification_object') }}
            <el-dropdown-menu slot="dropdown">
              <el-button @click="addObject" class="dropdown-btn">{{ $t('selectMsg.Customize') }}</el-button>
              <el-dropdown-item v-for="(item, index) in objectList" :key="index" class="dropdown-item">
                <el-checkbox border :checked="item.checked" @change="handleSelect($event, item)">{{ item.name }}</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </el-form-item>
        <el-form-item>
          <NoticeObject ref="notice" />
        </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
          <el-button type="primary" @click="isShowDialog = false">{{ $t('public.btn_close') }}</el-button>
          <el-button type="primary" @click="handleSave">{{ $t('public.btn_confirm') }}</el-button>
      </div>
    </modal>

  </div>
</template>

<script>
import { saveCalibrationBatch, getCalibrationInfo } from '@/api/modules/sensor.js'
import NoticeObject from '@/components/NoticeObject/index.vue'


export default {
  name: 'CalibrationDialog',
  components: { NoticeObject},
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    choozeTableData: {
      type: Array,
      default: () => []
    },
    // 列表操作列中选择的单个设备
    rowData: {
      type: Object,
      default: () => {}
    },
    // 是否单条
    singleCalibration: {
      type: Boolean,
      default: false
    },
    // 是传感器还是气体还是门磁，传感器：0，气体：5，门磁：6
    devType: {
      type: Number,
      default: 0
    }
  },
  watch: {
    isShowDialog (){
      if(this.isShowDialog){
        console.log('isShowDialog--------------------------', this.singleCalibration)
        if(this.singleCalibration){
          this.tableData = [this.rowData]

        }else{
          this.tableData = [...this.choozeTableData]
        }
      }
      console.log('tableData=', this.tableData)
    }
  },
  mounted(){
    if(this.singleCalibration){
      this.tableData = [this.rowData]
      this.getCalibration(this.tableData[0].id)
    }else{
      this.tableData = [...this.choozeTableData]
    }
  },
  data() {
    return {
      tableData: [], // 选择的设备列表
      dioForm: {
        // deviceId: null, //设备id
        deviceIdList: [], // 设备id list
        type: 1, //0 - 免校准，1-开启校准
        expireTime: null, //到期时间
        day: 1, //提前通知天数
        time: null, //时间
        // objectList: [ //通知对象
        //   {
        //     isSyn：0, // 是否同步
        //     notice： {
        //       way: null, // 通知方式 0-否，1-是；第一位
        //       name: null,
        //       email: null,
        //       phone: null
        //     }

        //   }
        // ],
        objectList: []
      },
      noticeChecked: true, // 是否开启校准通知

      // 限制日期选择时间在今天之后
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() < Date.now()
        }
      },
    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    }
  },
  methods: {
    async justify () {
      try {
        return await this.$refs.form.validate()
      } catch (error) {
        return false
      }
    },
    // 保存校准
    async handleSave(){
      const flag = await this.justify()
      if (!flag) return

      // 判断校准通知时间是否在当前日期之后（免校准不用判断）
      console.log('dioForm=', this.dioForm)
      if(this.dioForm.type === 1){
        let expireTime = this.$dateParseTime(this.dioForm.expireTime)
        let day = this.dioForm.day * 24 * 60 * 60 * 1000
        let time = parseInt(this.dioForm.time.split(':')[0]) * 60 * 60 * 1000 + parseInt(this.dioForm.time.split(':')[1]) * 60 * 1000
        let noticeTime = expireTime - day + time
        if(noticeTime < Date.now()){
          this.$message.warning(this.$t('device.calibration_notice_time_tips'))
          return
        }
      }

      const idList = this.tableData.map(item => item.id)
      this.dioForm.deviceIdList = idList
      // 整理已选择通知对象数据
      // this.selectObjectList.forEach(item => {
      //   let way1 = item.smsOpen ? '1' : '0'
      //   let way2 = item.emailOpen ? '1' : '0'
      //   let way3 = item.phoneOpen ? '1' : '0'
      //   this.dioForm.objectList.push({
      //     isSyn: item.isSyn,
      //     notice: {
      //       way: way1 + way2 + way3,
      //       name: item.name,
      //       email: item.email,
      //       phone: item.phone
      //     }
      //   })
      // });
      // 获取通知对象数据
      this.dioForm.objectList = []
      let selectObjectList = this.$refs.notice ? this.$refs.notice.selectObjectList : []
      console.log('selectObjectList=', selectObjectList)
      selectObjectList.forEach(obj => {
        this.dioForm.objectList.push({
          isSyn: obj.isSyn,
          notice: {
            way: '' + obj.smsOpen + obj.emailOpen + obj.phoneOpen,
            name: obj.name,
            email: obj.email,
            phone: obj.phone
          }
        })
      })
      // 时间格式转化
      this.dioForm.expireTime = this.$dateParseTime(this.dioForm.expireTime)
      saveCalibrationBatch(this.dioForm, this.devType).then(({ state }) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.isShowDialog = false
          this.$parent.getListFn()
        } else {
          this.$message.error(state.msg)
        }
      })
    },
    // 是否开启校准通知
    noticeChange(checked){
      this.noticeChecked = checked
    },
    reset(){
      this.dioForm = {
        deviceIdList: [],
        type: 1,
        expireTime: null,
        day: 10,
        time: null,
        objectList: []
      }
    },
    getCalibration(id){
      getCalibrationInfo(id, this.devType).then(res => {
        if (res.state.code === 200 && res.result) {
            this.dioForm = res.result
            this.$refs.notice.setNoticeList(this.dioForm.objectList)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add_object_btn {
  margin-left: 50px;
  ::v-deep i {
    color: #FFFFFF !important;
  }
  .dropdown-btn {
    width: 100%;
  }
  .dropdown-item {
    margin: 2px 0;
  }
}
.icon_btns {
  i {
    margin: 0 5px;
    font-size: 20px;
    &:last-child {
      float: right;
    }
  }
}
.items {
  display: flex;
  margin-bottom: 8px;
  .item-icon {
    padding: 5px;
    border: 1px solid #CCCCCC;
    font-size: 18px;
  }
  .item-name {
    width: 360px;
    background-color: var(--primary-color);
    text-align: center;
    color: #FFFFFF;
  }
}

</style>
